export const MIN_AMOUNT_PROMISSORY_NOTE_DT = 50000;

export const CREDIT_LIMIT_RANGES_DT = [
  {
    min: 0,
    max: 50000,
  },
  {
    min: 50000,
    max: 100000,
  },
  {
    min: 100000,
    max: 500000,
  },
];
